import React from "react";
import AppSidebar from "../components/appSidebar";
import AppHeader from "../components/appHeader";
import AppContent from "../components/appContent";

/**
 * @function MainLayout
 * @description Persistent admin chrome. Child routes render through Outlet
 * inside AppContent so the sidebar and header stay mounted.
 * @returns JSX for MainLayout
 */
const MainLayout = () => {
  return (
    <div className="admin-layout">
      <AppSidebar />
      <div className="wrapper d-flex flex-column min-vh-100">
        <AppHeader />
        <div className="body flex-grow-1">
          <AppContent />
        </div>
      </div>
    </div>
  );
};

export default React.memo(MainLayout);
